export type LiveCategory = "game" | "entertainment" | "sports";
export type LiveStatus = "live" | "upcoming";

export interface LiveItem {
  id: string;
  title: string;
  streamer: string;
  category: LiveCategory;
  cover: string;
  viewers: number;
  status: LiveStatus;
  startTime: string;
  resolution: string;
  tags: string[];
  description: string;
}

export const liveItems: LiveItem[] = [
  {
    id: "1001",
    title: "星域争霸 职业联赛半决赛 巅峰对决",
    streamer: "电竞老炮儿",
    category: "game",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20dark%20esports%20arena%20scene%20with%20glowing%20azure%20blue%20stage%20lights%2C%20giant%20LED%20screen%2C%20dramatic%20haze%2C%20futuristic%20technology%20atmosphere%2C%20high%20detail%2C%20moody%20cool%20tones%2C%20wide%20composition&width=800&height=450&seq=live-cover-01&orientation=landscape",
    viewers: 284500,
    status: "live",
    startTime: "今天 20:00",
    resolution: "蓝光 1080P+",
    tags: ["官方赛事", "中文解说", "高能团战"],
    description:
      "星域争霸职业联赛四强争夺战，两支顶级战队正面碰撞。老牌强队对阵本赛季最大黑马，地图运营与团战细节拉满。主播全程第一视角解说，深度复盘每一波关键决策，带你感受职业选手的操作强度。",
  },
  {
    id: "1002",
    title: "绝地求生 四排吃鸡教学 稳健运营流",
    streamer: "落地成盒王",
    category: "game",
    cover:
      "https://readdy.ai/api/search-image?query=Dark%20battle%20royale%20game%20environment%20concept%2C%20ruined%20urban%20city%20at%20dusk%20with%20neon%20azure%20glow%2C%20cinematic%20fog%2C%20dramatic%20contrast%2C%20highly%20detailed%20digital%20art%2C%20cool%20blue%20and%20charcoal%20palette&width=800&height=450&seq=live-cover-02&orientation=landscape",
    viewers: 96300,
    status: "live",
    startTime: "今天 19:30",
    resolution: "超清 1080P",
    tags: ["战术教学", "四排", "新手友好"],
    description:
      "落地成盒王带你看懂稳健运营的正确打开方式。从跳伞落点、物资分配、圈边转移，到决赛圈卡点架枪，一步步拆解四排配合思路，适合刚入门想提升胜率的玩家。",
  },
  {
    id: "1003",
    title: "开放世界冒险《黎明之环》首播实况",
    streamer: "阿黎的旅行",
    category: "game",
    cover:
      "https://readdy.ai/api/search-image?query=Mystical%20open%20world%20fantasy%20landscape%20concept%20art%2C%20floating%20ruins%20and%20glowing%20azure%20magic%20light%2C%20dramatic%20sunset%20sky%2C%20cinematic%20wide%20shot%2C%20highly%20detailed%20matte%20painting%2C%20cool%20color%20tones&width=800&height=450&seq=live-cover-03&orientation=landscape",
    viewers: 41200,
    status: "upcoming",
    startTime: "今天 22:00",
    resolution: "蓝光 1080P+",
    tags: ["新游首播", "剧情向", "探索"],
    description:
      "备受期待的开放世界大作《黎明之环》发售首日直播。阿黎将带大家从序章一路探索到第一个大型地图区域，聊聊美术、剧情与战斗手感，欢迎弹幕一起讨论。",
  },
  {
    id: "1004",
    title: "英雄联盟 峡谷之巅王者冲分",
    streamer: "中单一哥",
    category: "game",
    cover:
      "https://readdy.ai/api/search-image?query=Futuristic%20MOBA%20battle%20arena%20concept%2C%20glowing%20azure%20energy%20crystals%20and%20dark%20stone%20lanes%2C%20dramatic%20overhead%20lighting%2C%20sci-fi%20fantasy%20atmosphere%2C%20highly%20detailed%20digital%20illustration&width=800&height=450&seq=live-cover-04&orientation=landscape",
    viewers: 158700,
    status: "live",
    startTime: "今天 18:00",
    resolution: "超清 1080P",
    tags: ["排位", "中路", "carry"],
    description:
      "峡谷之巅王者段位持续冲分，主打中单刺客体系。每一局都会讲解对线细节、支援时机与团战切入角度，喜欢中路 Carry 的玩家别错过。",
  },
  {
    id: "1005",
    title: "主机单机《暗影之城》硬核通关",
    streamer: "手柄小王子",
    category: "game",
    cover:
      "https://readdy.ai/api/search-image?query=Dark%20noir%20city%20street%20at%20night%20with%20rain%20reflections%2C%20neon%20azure%20signs%2C%20lone%20hooded%20figure%2C%20cinematic%20moody%20lighting%2C%20highly%20detailed%20atmospheric%20digital%20painting%2C%20cool%20blue%20tones&width=800&height=450&seq=live-cover-05&orientation=landscape",
    viewers: 33800,
    status: "upcoming",
    startTime: "明天 20:30",
    resolution: "高清 720P",
    tags: ["单机", "剧情", "沉浸"],
    description:
      "硬核动作游戏《暗影之城》一周目无伤挑战。手柄小王子会分享闪避判定、Boss 弱点与装备搭配思路，喜欢单机大作的观众可以一起追。",
  },
  {
    id: "2001",
    title: "深夜电台 点歌陪聊 治愈你的夜晚",
    streamer: "晚风姐姐",
    category: "entertainment",
    cover:
      "https://readdy.ai/api/search-image?query=Cozy%20intimate%20late%20night%20radio%20studio%20interior%2C%20warm%20ambient%20lamp%20glow%20contrasting%20dark%20cool%20room%2C%20microphone%20and%20headphones%2C%20cinematic%20shallow%20depth%20of%20field%2C%20highly%20detailed%20moody%20photography%20style&width=800&height=450&seq=live-cover-06&orientation=landscape",
    viewers: 67400,
    status: "live",
    startTime: "今天 23:00",
    resolution: "超清 1080P",
    tags: ["电台", "点歌", "闲聊"],
    description:
      "每晚的深夜陪伴时间。点一首歌，聊一段心事，晚风姐姐陪你度过安静的夜晚。欢迎在弹幕里留下你想听的歌和想说的话。",
  },
  {
    id: "2002",
    title: "街头美食探店 城市烟火气巡礼",
    streamer: "干饭不出门",
    category: "entertainment",
    cover:
      "https://readdy.ai/api/search-image?query=Bustling%20night%20street%20food%20market%20with%20warm%20glowing%20lanterns%20and%20steam%2C%20dark%20cool%20evening%20atmosphere%2C%20cinematic%20bokeh%2C%20rich%20detail%2C%20appetizing%20food%20stalls%2C%20moody%20photographic%20style&width=800&height=450&seq=live-cover-07&orientation=landscape",
    viewers: 51200,
    status: "live",
    startTime: "今天 18:30",
    resolution: "超清 1080P",
    tags: ["美食", "探店", "户外"],
    description:
      "跟着干饭不出门一起扫街！本期探访老城区夜市，从小吃到甜品一家家试吃，还会和摊主聊聊背后的故事，弹幕点单我来吃。",
  },
  {
    id: "2003",
    title: "钢琴即兴演奏 治愈系音乐现场",
    streamer: "钢琴小鹿",
    category: "entertainment",
    cover:
      "https://readdy.ai/api/search-image?query=Grand%20piano%20on%20a%20dark%20concert%20stage%20under%20a%20single%20soft%20spotlight%2C%20elegant%20minimal%20stage%20design%2C%20cinematic%20atmospheric%20lighting%2C%20refined%20mood%2C%20highly%20detailed%20photographic%20style&width=800&height=450&seq=live-cover-08&orientation=landscape",
    viewers: 28600,
    status: "upcoming",
    startTime: "明天 21:00",
    resolution: "蓝光 1080P+",
    tags: ["音乐", "钢琴", "现场"],
    description:
      "一场纯粹的音乐现场。钢琴小鹿会带来经典改编与即兴创作，也会根据弹幕给出的关键词现场编曲，安静听歌、慢慢放松。",
  },
  {
    id: "2004",
    title: "手作陶艺 沉浸式拉坯创作",
    streamer: "泥土先生",
    category: "entertainment",
    cover:
      "https://readdy.ai/api/search-image?query=Hands%20shaping%20clay%20on%20a%20pottery%20wheel%20in%20a%20dark%20cozy%20studio%2C%20warm%20soft%20light%2C%20artistic%20craft%20atmosphere%2C%20cinematic%20shallow%20depth%20of%20field%2C%20highly%20detailed%2C%20refined%20mood&width=800&height=450&seq=live-cover-09&orientation=landscape",
    viewers: 19300,
    status: "live",
    startTime: "今天 20:15",
    resolution: "高清 720P",
    tags: ["手工", "解压", "ASMR"],
    description:
      "慢节奏手作直播。泥土先生从拉坯、修坯到上釉一步步演示，配合轻柔的环境音，非常适合当作解压背景音，欢迎弹幕提问制陶细节。",
  },
  {
    id: "3001",
    title: "世界杯预选赛 焦点战中文解说",
    streamer: "老球评",
    category: "sports",
    cover:
      "https://readdy.ai/api/search-image?query=Dramatic%20floodlit%20soccer%20stadium%20at%20night%20from%20above%2C%20vivid%20green%20pitch%20and%20bright%20stadium%20lights%20against%20dark%20sky%2C%20cinematic%20wide%20angle%2C%20high%20detail%20sports%20atmosphere&width=800&height=450&seq=live-cover-10&orientation=landscape",
    viewers: 412900,
    status: "live",
    startTime: "今天 20:45",
    resolution: "蓝光 1080P+",
    tags: ["足球", "赛事直播", "解说"],
    description:
      "世界杯预选赛关键一战，老球评陪你全程观赛。赛前阵容分析、实时战术解读、赛后复盘一网打尽，弹幕一起为喜欢的球队加油。",
  },
  {
    id: "3002",
    title: "CBA 常规赛 现场直击 高清多机位",
    streamer: "篮下解说员",
    category: "sports",
    cover:
      "https://readdy.ai/api/search-image?query=Indoor%20basketball%20arena%20during%20a%20night%20game%2C%20bright%20court%20lights%20and%20crowd%20atmosphere%20against%20dark%20surrounding%2C%20dynamic%20cinematic%20angle%2C%20high%20detail%20sports%20photography%20style&width=800&height=450&seq=live-cover-11&orientation=landscape",
    viewers: 187300,
    status: "live",
    startTime: "今天 19:35",
    resolution: "超清 1080P",
    tags: ["篮球", "联赛", "多机位"],
    description:
      "CBA 常规赛现场直播，篮下解说员带你直击每一次攻防。多机位切换配合实时数据面板，重点球员的精彩瞬间一个都不错过。",
  },
  {
    id: "3003",
    title: "环湖自行车赛 全程跟拍挑战",
    streamer: "骑行者老周",
    category: "sports",
    cover:
      "https://readdy.ai/api/search-image?query=Cyclists%20racing%20along%20a%20scenic%20lakeside%20mountain%20road%20at%20golden%20hour%2C%20cinematic%20aerial%20view%2C%20motion%20blur%2C%20dramatic%20landscape%2C%20highly%20detailed%20sports%20photography&width=800&height=450&seq=live-cover-12&orientation=landscape",
    viewers: 24800,
    status: "upcoming",
    startTime: "周六 07:00",
    resolution: "高清 720P",
    tags: ["骑行", "户外", "耐力"],
    description:
      "环湖 120 公里骑行挑战全程跟拍。从出发的热身节奏、中途补给策略到最后的冲刺阶段，老周会分享长途骑行的配速与补给经验。",
  },
];